var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header',{ref:"header"}),_c('transition',{attrs:{"mode":"out-in"}},[_c('router-view',{key:_vm.$route.fullPath,ref:"routerView",on:{"loginSuccess":_vm.loginSuccess}})],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }